import { FREE_EMAIL_PROVIDERS } from './free-email-providers';

/**
 * Get the domain from an email
 */
export function getDomainFromEmail(email: string): string {
    const match = email.match(/^([^@]*)@(\S*)/);
    const domain = match ? match[2] : '';

    return domain;
}

/**
 * Get the email domain when the user is using a work email (null otherwise)
 */
export function getWorkDomainFromEmail(email: string): string | null {
    const domain = getDomainFromEmail(email);
    return isWorkEmailDomain(domain) ? domain : null;
}

/**
 * Test if an email domain is a work one.
 * This method can return different results between frontend and backend.
 */
export function isWorkEmailDomain(domain: string): boolean {
    return !FREE_EMAIL_PROVIDERS.includes(domain);
}
